<app-navmenu></app-navmenu>
<div class="app-container">

    <main class="main-content">
        <router-outlet></router-outlet>
    </main>

    <footer class="footer fondoazul2">
        <app-footer></app-footer>
    </footer>
</div>